import React from 'react'
import { connect } from 'react-redux'
import toLower from 'lodash/toLower'

import AttractionActions from '../../Redux/AttractionRedux'

class AttractionUpdate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: null,
      form: {
        language_code: toLower(props.setting.language_code),
        highlights: '',
        additional_info: '',
        description: '',
        meta_description: '',
        meta_title: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      form: {
        ...this.state.form,
        highlights: nextProps.attraction.detail.highlights,
        additional_info: nextProps.attraction.detail.additional_info,
        description: nextProps.attraction.detail.description,
        meta_description: nextProps.attraction.detail.meta_description || '',
        meta_title: nextProps.attraction.detail.meta_title || ''
      }
    })
  }

  componentDidMount = () => {
    let filter = {
      language_code: this.props.setting.language_code,
      currency_code: this.props.setting.currency_code
    }
    let data = {
      id: this.props.detailId,
      filter
    }
    this.props.getAttractionDetail(data)
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = () => {
    const form = this.state.form
    const data = {
      id: this.props.attraction.detail.id,
      form
    }
    this.props.updateAttractionDetail(data)
    this.props.closeModal()
  }

  render () {
    const { fetching, err, processing } = this.props.attraction

    return (
      <div className='section' style={{ width: '75vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Update Attraction Detail
            {(fetching || processing) && <div className='badge badge-info ml-2'>{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className='alert alert-danger'>{err}</div>}
        <form>
          <div className='form-group'>
            <label htmlFor='highlights' className='control-label'>Highlights</label>
            <textarea name='highlights' rows='5' className='form-control' onChange={(event) => this._inputChange(event, 'highlights')} value={this.state.form.highlights} />
          </div>
          <div className='form-group'>
            <label htmlFor='additional_info' className='control-label'>Additional Info</label>
            <textarea name='additional_info' rows='10' className='form-control' onChange={(event) => this._inputChange(event, 'additional_info')} value={this.state.form.additional_info} />
          </div>
          <div className='form-group'>
            <label htmlFor='description' className='control-label'>Description</label>
            <textarea name='description' rows='15' className='form-control' onChange={(event) => this._inputChange(event, 'description')} value={this.state.form.description} />
          </div>
          <div className='form-group'>
            <label htmlFor='meta_description' className='control-label'>Meta-description</label>
            <textarea name='meta_description' rows='3' className='form-control' onChange={(event) => this._inputChange(event, 'meta_description')} value={this.state.form.meta_description} />
          </div>
          <div className='form-group'>
            <label htmlFor='meta_title' className='control-label'>Meta-title</label>
            <textarea name='meta_title' rows='3' className='form-control' onChange={(event) => this._inputChange(event, 'meta_title')} value={this.state.form.meta_title} />
          </div>
        </form>
        <div className='form-group d-flex justify-content-end'>
          <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
          <button className='btn btn-lg btn-primary ml-2' onClick={() => this._submit()}>Save</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction
})

const dispatchToProps = (dispatch) => ({
  getAttractionDetail: (data) => dispatch(AttractionActions.attractionDetailRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AttractionUpdate)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/FormUpdateDetail.js